/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * https://onestore-dev.gitbook.io/dev/eng/tools/tools/v21/one-store-iap-server-api-api-v7#market-classification
 * @export
 * @enum {string}
 */
export var FxGamesIntegrationOneStoreOneStoreMarketClassification;
(function (FxGamesIntegrationOneStoreOneStoreMarketClassification) {
    FxGamesIntegrationOneStoreOneStoreMarketClassification[FxGamesIntegrationOneStoreOneStoreMarketClassification["Unspecified"] = 0] = "Unspecified";
    FxGamesIntegrationOneStoreOneStoreMarketClassification[FxGamesIntegrationOneStoreOneStoreMarketClassification["Korea"] = 1] = "Korea";
    FxGamesIntegrationOneStoreOneStoreMarketClassification[FxGamesIntegrationOneStoreOneStoreMarketClassification["Global"] = 2] = "Global";
    FxGamesIntegrationOneStoreOneStoreMarketClassification[FxGamesIntegrationOneStoreOneStoreMarketClassification["NUMBER_unknown_default_open_api"] = 11184809] = "NUMBER_unknown_default_open_api";
})(FxGamesIntegrationOneStoreOneStoreMarketClassification || (FxGamesIntegrationOneStoreOneStoreMarketClassification = {}));
export function instanceOfFxGamesIntegrationOneStoreOneStoreMarketClassification(value) {
    for (const key in FxGamesIntegrationOneStoreOneStoreMarketClassification) {
        if (Object.prototype.hasOwnProperty.call(FxGamesIntegrationOneStoreOneStoreMarketClassification, key)) {
            if (FxGamesIntegrationOneStoreOneStoreMarketClassification[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function FxGamesIntegrationOneStoreOneStoreMarketClassificationFromJSON(json) {
    return FxGamesIntegrationOneStoreOneStoreMarketClassificationFromJSONTyped(json, false);
}
export function FxGamesIntegrationOneStoreOneStoreMarketClassificationFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function FxGamesIntegrationOneStoreOneStoreMarketClassificationToJSON(value) {
    return value;
}
export function FxGamesIntegrationOneStoreOneStoreMarketClassificationToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=FxGamesIntegrationOneStoreOneStoreMarketClassification.js.map